// Starter CSV + JSON shown in the recipes bulk-import modal. Mirrors the
// shape recognized by `buildRecipeBulkImportPreview` so an operator can
// download the CSV, fill it in, and paste it back without remembering the
// schema.

const HEADERS = [
  "recipe_code",
  "recipe_name",
  "recipe_kind",
  "recipe_tags",
  "recipe_notes",
  "line_kind",
  "line_material_name",
  "line_component_recipe_code",
  "line_material_use_code",
  "line_quantity",
  "line_role",
  "line_slot_label",
  "line_upgrade_price_delta",
] as const;

const NEEDS_QUOTING = /[",\n\r]/;

function escapeCell(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = typeof value === "string" ? value : String(value);
  if (!NEEDS_QUOTING.test(s)) return s;
  return `"${s.replace(/"/g, '""')}"`;
}

function rowsToCsv(rows: Array<Array<unknown>>): string {
  const lines = [HEADERS.join(",")];
  for (const r of rows) lines.push(r.map(escapeCell).join(","));
  return lines.join("\n") + "\n";
}

// Product with material + sub-recipe lines, plus a small option recipe.
export const EXAMPLE_RECIPE_BULK_IMPORT_CSV = rowsToCsv([
  [
    "8X10-LOFT",
    "8x10 Lofted Barn",
    "product",
    "wood;lofted",
    "",
    "material",
    "2x4 Stud",
    "",
    "",
    42,
    "structural",
    "wall_studs",
    "",
  ],
  [
    "8X10-LOFT",
    "",
    "",
    "",
    "",
    "component",
    "",
    "ROOF-GABLE",
    "",
    1,
    "structural",
    "roof",
    "",
  ],
  [
    "8X10-LOFT",
    "",
    "",
    "",
    "",
    "material",
    "Premium Door",
    "",
    "",
    1,
    "upgrade_option",
    "door",
    250.0,
  ],
  [
    "OPT-WINDOW-2424",
    "24x24 Single-Hung Window Option",
    "option",
    "exterior;window",
    "",
    "material",
    "24x24 Window",
    "",
    "",
    1,
    "upgrade_option",
    "window",
    180.0,
  ],
]);

export const EXAMPLE_RECIPE_BULK_IMPORT_JSON = `[
  {
    "code": "8X10-LOFT",
    "name": "8x10 Lofted Barn",
    "kind": "product",
    "tags": ["wood", "lofted"],
    "lines": [
      { "line_kind": "material", "material_name": "2x4 Stud", "quantity": 42, "role": "structural", "slot_label": "wall_studs" },
      { "line_kind": "component", "component_recipe_code": "ROOF-GABLE", "quantity": 1, "role": "structural", "slot_label": "roof" },
      { "line_kind": "material", "material_name": "Premium Door", "quantity": 1, "role": "upgrade_option", "slot_label": "door", "upgrade_price_delta": 250.00 }
    ]
  }
]`;
